/**
 * The line next to "Registru formabili": when the register was last taken
 * over, and how much changed since. Pure, so tested.
 */

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export function sinceText(since) {
  if (!since) return "";
  const parts = [];
  if (since.new) parts.push(plural(since.new, "nou", "noi"));
  if (since.changed) parts.push(plural(since.changed, "modificat", "modificați"));
  if (since.left) parts.push(plural(since.left, "ieșit", "ieșiți"));
  if (since.unfinished_changed) parts.push(`${since.unfinished_changed} schimbări la neterminați`);
  return parts.length ? parts.join(", ") : "nicio schimbare";
}

export function lastTakenOverText(status, fmt = (iso) => new Date(iso).toLocaleString("ro-RO", {
  day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
})) {
  if (!status?.last) return "Nu a fost preluată încă nicio descărcare: fișierul nu va avea nimic marcat.";
  const by = status.last.by ? `, de ${status.last.by}` : "";
  return `Ultima preluare: ${fmt(status.last.at)}${by} · de atunci: ${sinceText(status.since)}.`;
}
